// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"2c80b6e7","397":"257b7939","650":"a7213925","741":"d6142c90"}[chunkId] + ".chunk.js";
};